import $ from 'jquery'

export default class cockpitContactForm {
  constructor (element) {
    this.$element = $(element)
    this.$form = this.$element.find('form')
    this.$form.on('submit', this.handleFormSubmit.bind(this))
    this.$fields = this.$form.find('input,textarea,select')
    this.$fields.on('change keypress', this.handleFormChange.bind(this))
  }

  handleFormChange (event) {
    const $input = $(event.currentTarget)
    const $errorRow = this.getErrorForField($input)
    $errorRow.hide()
  }

  getErrorForField ($field) {
    const $formRow = $field.closest('.formRow')
    const $errorRow = $formRow.find('.formError')
    return $errorRow
  }

  handleFormSubmit (event) {
    const notRequiredFields = [
      'firma'
    ]

    const errorFields = []

    const formdata = this.$form.serializeArray()

    let privacyCheckIsSet = false;
    for (const fieldData of formdata) {
      if (fieldData.name === 'privacyCheck') {
        privacyCheckIsSet = true;
      }
      if (fieldData.value === '') {
        if (!notRequiredFields.includes(fieldData.name)) {
          errorFields.push(fieldData.name)
        }
      }
    }

    if (!privacyCheckIsSet) {
      errorFields.push('privacyCheck')
    }

    if (errorFields.length > 0) {
      for (const errorField of errorFields) {
        const $input = this.$form.find(`[name=${errorField}]`)
        const $errorRow = this.getErrorForField($input)
        $errorRow.show()
      }
      event.preventDefault()
      return
    }
  }
}
